import { render, staticRenderFns } from "./SystemPrintHeader.vue?vue&type=template&id=53646424&scoped=true"
import script from "./SystemPrintHeader.vue?vue&type=script&lang=js"
export * from "./SystemPrintHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53646424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53646424')) {
      api.createRecord('53646424', component.options)
    } else {
      api.reload('53646424', component.options)
    }
    module.hot.accept("./SystemPrintHeader.vue?vue&type=template&id=53646424&scoped=true", function () {
      api.rerender('53646424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/print/SystemPrintHeader.vue"
export default component.exports